<template>
  <basicLayout>
    <div class="container-fluid">
      <div class="row m-1">
        <div class="col">
          <h2>People (Contributors)</h2>
        </div>
      </div>

      <div class="row m-3">
        <div class="col-xl-6">
          <!-- <div class="row">
              <div class="col-xl-9"> -->
          <div class="input-group flex-wrap mb-3">
            <span class="input-group-text">Search...</span>

            <input
              @input="debounce_search"
              :value="search"
              type="text"
              class="form-control"
              placeholder="Name or FUGA Id"
            />

            <button
              @click="clear_search"
              class="btn btn-outline-secondary"
              type="button"
            >
              Clear
            </button>
          </div>
        </div>

        <div class="col-xl-6">
          <router-link
            :to="{ name: 'PersonCreate' }"
            type="button"
            class="btn btn-outline-secondary"
            >Create Person</router-link
          >
          <div class="btn-group ms-3" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              class="btn btn-outline-secondary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Export
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <li>
                <span
                  @click="download_people('selection')"
                  class="dropdown-item"
                >
                  <download-icon
                    size="1.2x"
                    class="custom-class me-2"
                  ></download-icon
                  ><span class="d-none d-xl-inline-block ml-1"
                    >Export Selection</span
                  ><span class="badge bg-light text-dark ms-2">{{
                    filtered.length
                  }}</span></span
                >
              </li>
              <li>
                <span @click="download_people('all')" class="dropdown-item">
                  <download-icon
                    size="1.2x"
                    class="custom-class me-2"
                  ></download-icon
                  ><span class="d-none d-xl-inline-block ml-1">Export All</span
                  ><span class="badge bg-light text-dark ms-2">{{
                    display_people.length
                  }}</span></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <!-- </div> -->

      <div class="row m-3">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-xl-6">
                  <div class="btn-group" data-toggle="buttons">
                    <label
                      class="btn btn-sm btn-outline-secondary"
                      :class="{
                        active: people_filter === 'all',
                      }"
                    >
                      <input
                        v-model="people_filter"
                        value="all"
                        type="radio"
                        class="btn-check nav-link"
                        autocomplete="off"
                      />
                      All
                    </label>
                    <label
                      class="btn btn-sm btn-outline-secondary"
                      :class="{
                        active: people_filter === 'inactive',
                      }"
                    >
                      <input
                        v-model="people_filter"
                        value="inactive"
                        type="radio"
                        class="btn-check nav-link"
                        autocomplete="off"
                      />
                      Inactive
                    </label>
                  </div>
                </div>

                <div class="col-xl-6 text-end">
                  Showing {{ filtered.length }} of {{ display_people.length }}
                </div>
              </div>
            </div>

            <div class="card-body">
              <table class="table table-sm table-hover">
                <thead class="table-dark sticky-top">
                  <tr>
                    <th
                      @click="sort_by('name')"
                      role="button"
                      class="text-left w-20"
                      scope="col"
                    >
                      Name
                      <span
                        v-if="sort_column === 'name' && sort_order === 'desc'"
                        ><chevron-down-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-down-icon
                      ></span>
                      <span
                        v-if="sort_column === 'name' && sort_order === 'asc'"
                        ><chevron-up-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-up-icon
                      ></span>
                    </th>

                    <th
                      @click="sort_by('date_created')"
                      role="button"
                      class="d-none d-xl-table-cell text-left"
                      scope="col"
                    >
                      Created
                      <span
                        v-if="
                          sort_column === 'date_created' &&
                          sort_order === 'desc'
                        "
                        ><chevron-down-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-down-icon
                      ></span>
                      <span
                        v-if="
                          sort_column === 'date_created' && sort_order === 'asc'
                        "
                        ><chevron-up-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-up-icon
                      ></span>
                    </th>

                    <th
                      @click="sort_by('created_by')"
                      role="button"
                      class="d-none d-xl-table-cell text-left"
                      scope="col"
                    >
                      Created By
                      <span
                        v-if="
                          sort_column === 'created_by' && sort_order === 'desc'
                        "
                        ><chevron-down-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-down-icon
                      ></span>
                      <span
                        v-if="
                          sort_column === 'created_by' && sort_order === 'asc'
                        "
                        ><chevron-up-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-up-icon
                      ></span>
                    </th>
                    <th
                      @click="sort_by('fuga_id')"
                      role="button"
                      class="d-none d-xl-table-cell text-left"
                      scope="col"
                    >
                      FUGA Id
                      <span
                        v-if="
                          sort_column === 'fuga_id' && sort_order === 'desc'
                        "
                        ><chevron-down-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-down-icon
                      ></span>
                      <span
                        v-if="sort_column === 'fuga_id' && sort_order === 'asc'"
                        ><chevron-up-icon
                          size="0.9x"
                          class="muted ms-1"
                        ></chevron-up-icon
                      ></span>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="person in filtered" :key="person.order_id">
                    <td class="text-left">{{ person.name }}</td>

                    <td class="d-none d-xl-table-cell text-left">
                      {{ person.date_created | moment_short }}
                    </td>

                    <td
                      @dblclick="filter_by(person.created_by)"
                      class="d-none d-xl-table-cell text-left"
                    >
                      {{ person.created_by }}
                    </td>

                    <td
                      @dblclick="fuga_record(person.fuga_id)"
                      class="d-none d-xl-table-cell text-left"
                    >
                      {{ person.fuga_id }}
                    </td>
                    <td class="w-5 text-center">
                      <router-link
                        :to="{
                          name: 'PersonProfile',
                          params: { person_id: person.id },
                        }"
                        title="edit person"
                      >
                        <edit-icon size="1x" class="text-success"></edit-icon>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <Pagination
            v-if="pages"
            :pages="pages"
            :selected_page="selected_page"
            v-on:updatePage="updatePage"
          />
        </div>
      </div>
      <!-- </div> -->
    </div>
  </basicLayout>
</template>

<script>
import { db } from "@/firebaseConfig";
import { orderBy } from "lodash";
import Papa from "papaparse";
import basicLayout from "@/components/basicLayout";
import filter_mixins from "@/mixins/filter_mixins";
import Pagination from "@/components/Pagination";
import {
  EditIcon,
  TrashIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  UserXIcon,
  MailIcon,
  UserCheckIcon,
  StarIcon,
  DownloadIcon,
  FileTextIcon,
} from "vue-feather-icons";

const people = db.collection("people");

export default {
  name: "People",
  data() {
    return {
      display_people: [],
      search: "",
      people_filter: "all",
      debounce: null,
      sort_column: ["name"],
      sort_order: "asc",
      page_limit: 30,
      selected_page: 1,
    };
  },
  components: {
    basicLayout,
    Pagination,
    EditIcon,
    TrashIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    UserXIcon,
    MailIcon,
    UserCheckIcon,
    StarIcon,
    DownloadIcon,
    FileTextIcon,
  },

  mixins: [filter_mixins],

  // created: async function () {
  //   const snapshot = await people.count().get();
  //   console.log(snapshot.data().count);
  // },

  methods: {
    debounce_search(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.search = event.target.value;
      }, 750);
    },

    clear_search() {
      this.search = "";
    },
    sort_by(column) {
      console.log("sorting by " + column);
      this.sort_column = column;
      this.sort_order = this.sort_order === "asc" ? "desc" : "asc";
    },
    filter_by(filter) {
      console.log("FILTER BY: " + filter);
      this.search = filter;
    },
    updatePage(value) {
      this.selected_page = value;
      this.clear_search();
    },

    download_people(selection) {
      let download_people;

      if (selection === "selection") {
        download_people = [...this.filtered];
      } else if (selection === "all") {
        download_people = [...this.display_people];
      }

      download_people = download_people.map((a) => {
        // console.log(
        //   new Date(latest_contract_date * 1000).toLocaleString("en-NZ")
        // );
        // a.latest_contract_date =
        //   (latest_contract_date &&
        //     new Date(latest_contract_date * 1000).toLocaleString("en-NZ")) ||
        //   "";

        a.date_created_string =
          (a.date_created &&
            new Date(a.date_created.seconds * 1000).toLocaleString("en-NZ")) ||
          "";
        return a;
      });

      const csv = Papa.unparse({
        data: download_people,
        fields: [
          "id",
          "name",
          "apple_id",
          "spotify_id",
          "date_created_string",
          "is_active",
        ],
        quotes: true,
      });
      const csv_name = "people.csv";

      console.log(csv_name);
      this.downloading = false;
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv," + encodeURIComponent(csv);
      anchor.download = csv_name;
      anchor.click();
    },
    fuga_record(id) {
      window.open(`https://next.fugamusic.com/person/${id}`, "_blank");
    },
  },
  computed: {
    filtered: function () {
      let visible_people = [...this.display_people];

      const search = this.search;

      let sort_column = this.sort_column;

      //   if (sort_column) {
      //     visible_people = orderBy(visible_people, sort_column || "", this.sort_order);
      //   }

      visible_people = visible_people.filter((person) => {
        // console.log(person.name);
        const s = (person.name || "") + person.fuga_id;
        const su = s.toUpperCase();
        // console.log(su);
        return su.match(search.toUpperCase());
      });
      if (!search) {
        const start = (this.selected_page - 1) * this.page_limit;
        const end = start + this.page_limit;
        visible_people = visible_people.slice(start, end);
      }

      return visible_people;
    },
    pages() {
      const pages_array = this.search ? this.filtered : this.display_people;
      return Math.ceil(pages_array.length / this.page_limit);
    },
  },
  watch: {
    people_filter: {
      immediate: true,
      handler(filter) {
        let query = people;
        if (filter && filter === "admin") {
          query = query.where("role", "==", "admin");
        } else if (filter && filter === "agent") {
          query = query.where("role", "==", "agent");
        } else if (filter && filter === "person") {
          query = query.where("role", "==", "person");
        } else if (filter && filter === "inactive") {
          query = query.where("is_active", "==", false);
        }
        // query = query.limit(5500);
        this.$bind("display_people", query);
      },
    },
  },
};
</script>

<style>
.table-fixed thead {
  width: 97%;
}
.table-fixed tbody {
  height: 230px;
  overflow-y: auto;
  width: 100%;
}
.table-fixed thead,
.table-fixed tbody,
.table-fixed tr,
.table-fixed td,
.table-fixed th {
  display: block;
}
.table-fixed tbody td,
.table-fixed thead > tr > th {
  float: left;
  border-bottom-width: 0;
}
</style>
